import styles from "./TopMenu.module.css";
import { useCookies } from "react-cookie";
import { useEffect, useState } from "react";
import { ListView } from "../common/ListView";
import { TopMenuList, TopMenuListProps } from "./TopMenuList";
import { AccountManager } from "../../workers/AccountManager";
import { path } from "../common/Common";

/**
 * @author yjkim
 * @date 2022-09-19 11:33
 * @remark 상단 헤더의 메뉴
 * 유저 grade(권한) 에 따라 표시되는 상단 메뉴가 다름
 * 추후 상단에 상단배너와 로그인 버튼이 추가될 수 있음
 * @returns Header JSX.Element
 */

function TopMenu() {
    // const [grade, setGrade] = useState(userInfo(0).data.grade); // 유저 권한 확인을 위한 변수
    // const [isAdminUser, setIsAdminUser] = useState(false);
    const [cookies] = useCookies(["KMTK"]); // 쿠키에서 로그인 토큰 가져오기

    const [menuData, setMenuData] = useState(Array<{}>);

    /**
     * @author sukim91
     * @date 2022-10-06 21:33
     * @remark AccountManager => 관리자 계정 확인 후 상단 메뉴 구성 체크
     */
    useEffect(() => {
        (async () => {
            const isAdminUser = await defineUserGrade();
            await createTopMenuByGrade(isAdminUser);
        })();
    }, [cookies.KMTK]); // KMTK 쿠키가 변경될때마다 실행

    const defineUserGrade = async () => {
        // axios 요청 대신 process 예시 데이터 반환
        // setGrade(userInfo(0).data.grade)
        // setGrade(userInfo(1).data.grade)
        // setGrade(userInfo(2).data.grade)
        const accountManager = AccountManager.getInstance();
        const isAdminUser = await accountManager.isAdminUser();

        return isAdminUser;
    };

    const createTopMenuByGrade = async (isAdminUser: boolean) => {
        const data: { text: string; link: string }[] = [
            {
                text: "모두의지도",
                link: path.ROOT,
            },
            {
                text: "지도만들기",
                link: path.CREATE_MAP,
            },
            {
                text: "가이드",
                link: path.GUIDE,
            },
            {
                text: "멤버십",
                link: path.PRICE_POLICY,
            },
            {
                text: "공개지도",
                link: path.PUBLIC_MAPLIST,
            },
            {
                text: "고객지원",
                link: path.SUPPORT,
            },
        ];
        if (isAdminUser) {
            data.push(
                // {
                //     text: "비공개지도",
                //     link: "/about/private_data",
                // },
                {
                    text: "통계대시보드",
                    link: path.STATISTICS,
                }
            );
        }

        if (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)) {
            setMenuData(data.filter((menu) => menu?.text !== "지도만들기"));
        } else {
            setMenuData(data);
        }
    };

    return (
        <div>
            <header className={styles.header}>
                <div className={styles.headerMenuWrapper}>
                    <ul className={styles.headerMenu}>
                        <ListView data={menuData} renderItem={(item, index) => <TopMenuList key={index} text={item.text} link={item.link} />} />
                    </ul>
                </div>
            </header>
        </div>
    );
}

export default TopMenu;
